const formatCurrency = (c: number, lang: string = "nb-NO") =>
  new Intl.NumberFormat(lang, { style: "currency", currency: window.ORGANIZATION_CURRENCY }).format(
    c,
  );

export default formatCurrency;
